import { render, staticRenderFns } from "./RawMaterialCard.vue?vue&type=template&id=3964a64a&scoped=true"
import script from "./RawMaterialCard.vue?vue&type=script&lang=js"
export * from "./RawMaterialCard.vue?vue&type=script&lang=js"
import style0 from "./RawMaterialCard.vue?vue&type=style&index=0&id=3964a64a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3964a64a",
  null
  
)

export default component.exports